// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Label_label-container__64zBH {
  font-size: 12px;
  font-weight: 600;
  line-height: 16px;
  margin-bottom: 6px;
  width: 100%;
  position: relative;
  color: var(--m-text);
}
.Label_label-container--required__g5mV0 {
  color: var(--m-danger);
  padding-left: 3px;
}`, "",{"version":3,"sources":["webpack://./src/components/BaseUI/Label/Label.module.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,oBAAA;AACJ;AACI;EACI,sBAAA;EACA,iBAAA;AACR","sourcesContent":[".label-container {\n    font-size: 12px;\n    font-weight: 600;\n    line-height: 16px;\n    margin-bottom: 6px;\n    width: 100%;\n    position: relative;\n    color: var(--m-text);\n\n    &--required {\n        color: var(--m-danger);\n        padding-left: 3px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label-container": `Label_label-container__64zBH`,
	"label-container--required": `Label_label-container--required__g5mV0`
};
export default ___CSS_LOADER_EXPORT___;
